import { Component, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import Ticket from 'models/ticket/ticket.model';
import { BehaviorSubject } from 'rxjs';
import { ConfigService } from 'services/config/config.service';
import { TicketService } from 'services/ticket/ticket.service';
import { TokenService } from 'services/token/token-service.service';

@Component({
  selector: 'app-gallery-ticket',
  templateUrl: './gallery-ticket.component.html',
  styleUrls: ['./gallery-ticket.component.scss'],
})
export class GalleryTicketComponent implements OnInit, OnDestroy {
  @Input() public instance: Ticket = new Ticket();
  public imgList: string[] = [];
  public refresh: BehaviorSubject<boolean> = new BehaviorSubject(true);
  public selectedIndex = null;
  public isChanging = false;
  public selectedToDownload = [];

  constructor(
    public dialogRef: MatDialogRef<GalleryTicketComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { ticket: Ticket },
    public ticketService: TicketService,
    public tokenService: TokenService,
    public configService: ConfigService,
  ) {
    if (data) {
      this.instance = data.ticket;
    }
  }

  async ngOnInit() {
    this.imgList = await this.ticketService.getImageList(this.instance.id);
    this.refresh.subscribe(async () => {
      this.imgList = await this.ticketService.getImageList(this.instance.id);
      if (this.imgList.length > 0) {
        this.selectedIndex = 0;
      }
    });
  }
  
  async delImg(image: string) {
    this.imgList = this.imgList.filter(i => i !== image);
    await this.ticketService.deleteImage(this.instance, image);
    this.imgList = await this.ticketService.getImageList(this.instance.id);
    this.refresh.next(true);
  }

  downloadTitle() {
    return `${this.selectedToDownload.length} db fálj letöltése`;
  }

  download(item) {
    var fileName = item.split(/(\\|\/)/g).pop();
  
    var image = new Image();
    image.crossOrigin = "anonymous";
    image.src = this.imageUrl(item);
    image.onload = () => {
    
      // use canvas to load image
      var canvas = document.createElement('canvas');
      canvas.width = image.naturalWidth;
      canvas.height = image.naturalHeight;
      canvas.getContext('2d').drawImage(image, 0, 0);
      
      // grab the blob url
      var blob;
      if (image.src.indexOf(".jpg") > -1) {
        blob = canvas.toDataURL("image/jpeg");
      } else if (image.src.indexOf(".png") > -1) {
        blob = canvas.toDataURL("image/png");
      } else if (image.src.indexOf(".gif") > -1) {
        blob = canvas.toDataURL("image/gif");
      } else {
        blob = canvas.toDataURL("image/png");
      }
  
      // create link, set href to blob
      var a = document.createElement('a');
      a.title = fileName;
      a.href = blob;
      a.style.display = 'none';
      a.setAttribute("download", fileName);
      a.setAttribute("target", "_blank");
      document.body.appendChild(a);
      
      // click item
      a.click();
    }
  }
  
  downloadAll(items) {
    for (let i in items) {
      this.download(items[i]);
    }
    this.selectedToDownload = [];
  }

  selectToDownload(img: string) {
    if (this.isSelectedToDownload(img)) {
      this.selectedToDownload = this.selectedToDownload.filter((image) => image !== img);
    } else {
      this.selectedToDownload.push(img);
    }
  }

  isSelectedToDownload(img: string) {
    return this.selectedToDownload.includes(img);
  }

  select(image: string) {
    this.selectedIndex = this.imgList.indexOf(image);
  }
  
  imageUrl(image: string) {
    return this.configService.getConfig().apiUrl + "/ticket/img/" + this.instance.id + "/" + this.tokenService.getIdToken() + "/" + image;
  }

  next() {
    this.isChanging = true;
    setTimeout(() => {
      if (this.imgList.length > this.selectedIndex + 1) {
        this.selectedIndex++;
      } else {
        this.selectedIndex = 0;
      }
      this.isChanging = false;
    }, 130);
  }

  previous() {
    this.isChanging = true;
    setTimeout(() => {
      if (this.selectedIndex > 0) {
        this.selectedIndex--;
      } else {
        this.selectedIndex = this.imgList.length - 1;
      }
      this.isChanging = false;
    }, 130);
  }

  close(event: MouseEvent) {
    event.stopPropagation();
    this.selectedIndex = null;
  }

  ngOnDestroy() {
    this.refresh.complete();
  }
}
